import { Radio as DigdirRadio, useRadioGroup, } from "@digdir/designsystemet-react";
const Radio = DigdirRadio;
Radio.displayName = "Radio";
export { Radio, useRadioGroup };
//# sourceMappingURL=radio.js.map